<template>
  <AtomsHeading2 class="mb-4">Cancellation Policy</AtomsHeading2>
  <AtomsParagraphSub style="white-space: pre-line"> {{ cancelFeeMessage }} </AtomsParagraphSub>
</template>

<script setup lang="ts">
import { buildCancelFeeMessage, type WabunkaCancellationPolicyTrigger } from '@/wabunka-src/features/Experience/models/cancellationPolicyTrigger';

interface Props {
  isLadderEnabled?: boolean;
  cancellationPolicyTrigger: WabunkaCancellationPolicyTrigger;
  refundableCancellationDaysForGuest: number;
}

const props = defineProps<Props>();

const cancelFeeMessage = computed(() => buildCancelFeeMessage(props.cancellationPolicyTrigger, props.refundableCancellationDaysForGuest, props.isLadderEnabled));
</script>
